import React, { useEffect, useState } from 'react';
import { getPageData } from "../api/pageService";
import { sleep } from "../utils/sleep";
import { Link } from 'react-router-dom';
import { Title, Meta, Link as SeoLink } from "react-head";
import Services from '../components/Service';
import WhyUs from '../components/WhyUs';
import Projects from '../components/Projects';
import Industries from '../components/Industries';
import TechStack from '../components/TechStack';
import Testimonials from '../components/Testimonials';
import WhoWeAre from '../components/WhoWeAre';
import FinalCTA from '../components/FinalCTA';
import Hero from '../components/Hero';

const Home = () => {
  const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

   useEffect(() => {
          const fetchPageData = async () => {
            try {
              // simulate network delay (3 sec)
              //await sleep(3000);
    
              const data = await getPageData("home"); // asynchronous call
              setPageData(data);
            } catch (err) {
              setError("Failed to load home page data.");
            } finally {
              setLoading(false);
            }
          };
      
          fetchPageData();
    }, []);
    
  return (
    <>
      {/* SEO Section */}
    <Title>{pageData? pageData.seo.title:''}</Title>
          <Meta
            name="description"
            content={pageData?pageData.seo.description:''}
          />
          <SeoLink rel="canonical" href={pageData?pageData.seo.canonical:''} />

      <div className="home-page">

      {/* About Preview */}
      <Hero/>

      {/* About Preview */}
      <WhoWeAre/>

      {/* Services */}
    <Services />
          
    {/* WhyUs */}
      <WhyUs />

     {/* Industries */}
      <Industries />
      
      {/* Projects Preview */}
      <Projects />
      
      {/* Testimonials */}
      <Testimonials />

      {/* TechStack */}
      <TechStack />

      {/* Final CTA */}
      <FinalCTA/>
      </div>
      </>
  );
};

export default Home;
